import Faqs from "./Faqs";

const GeometryAndAdjustmentsFaq = () => {
  return (
    <Faqs
      faqs={[
        {
          question: "How to set Brake lever angles?",
          answer: (
            <p>
              In your standing riding position, your wrists should be straight
              through to your brake finger as it covers the brake. This enables
              a strong grip and efficient blood flow through your wrists,
              reducing arm pump. There is a level of preference in feeling here
              too.
            </p>
          ),
        },
        {
          question: "How to set Bar Height?",
          answer: (
            <p>
              From bike to bike your optimum bar height will change. You can
              increase or decrease with the use of stem rise, headset spacers,
              stem spacers and handlebar rise. It's about finding the right
              balance between comfort, control, and performance. It affects your
              center of gravity, handling, and how much weight is distributed
              between the front and rear wheels. If you have an even balance in
              sag but your front wheel feels light, washy and unpredictable,
              this could be a sign to lower the height.
            </p>
          ),
        },
        {
          question: "How to set reach?",
          answer: (
            <p>
              Your frame size is the number one variable for reach. The correct
              size frame is crucial, but there are fine adjustments. Different
              length stems, extend or reduce your reach. Some frames offer
              larger diameter headsets and options to increase or reduce reach
              too. Lowering your handlebar height will also increase your reach,
              much like a higher handlebar can reduce it.
            </p>
          ),
        },
        {
          question: "How to set spoke tension?",
          answer: (
            <>
              <p>
                Spoke tensions are commonly overlooked but are a very effective
                aspect to how your bike flexes and reacts.
              </p>
              <p>
                <strong>Even, proper tension</strong> = strong, reliable wheel
                that stays true under big hits.
              </p>
              <p>
                <strong>Looser</strong> = flexy wheel, less prone to pinch flats
                and better tracking. Rough terrain will feedback less to your
                hands.
              </p>
              <p>
                <strong>Tighter</strong> = risk of rim damage is higher but more
                precise, more of the energy you put in through pumping or
                pedalling with transfer to the ground.
              </p>
            </>
          ),
        },
        {
          question: "How to set tyre pressure?",
          answer: (
            <>
              <p>
                Tyre pressures range largely across disciplines and tyre models
                and different tracks will have different demands.
              </p>
              <p>
                In general a softer tyre pressure will flex, giving more grip,
                better tracking and less feedback to the rider. The risk of tyre
                roll is higher in compressions, taking off or landing.
              </p>
              <p>
                A harder tyre pressure will roll faster and be more predictable
                but give a lot of feedback.
              </p>
            </>
          ),
        },
      ]}
    />
  );
};

export default GeometryAndAdjustmentsFaq;
